module.exports = __webpack_public_path__ + "img/linkedin-sales-solutions-9KrLgnMc3OE-unsplash.e83b4fc4.png";